<!--
 * @Author: cryi.liu
 * @Date: 2020-05-15 15:15:42
 * @LastEditTime: 2020-05-27 14:29:47
 * @Description: 多项选或不定项选择作答区
-->
<template>
  <div class="multiple-choice">
    <i-checkbox-group v-model="values" size="small" @on-change="multipleChoiceSelectChanged">
      <i-checkbox
        v-for="option in options"
        :key="option.id"
        :label="option.id">{{ option.content }}</i-checkbox>
    </i-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'MultipleChoice',
  props: {
    options: { type: Array, required: true },
  },
  data() {
    return {
      values: [],
    };
  },
  watch: {
    options: {
      immediate: true,
      handler(options) {
        this.values = [];
        options.forEach((option) => {
          if (option.correct) {
            this.values.push(option.id);
          }
        });
      },
    },
  },
  methods: {
    /**
     * 多项或不定项选择发生改变时
     */
    multipleChoiceSelectChanged(values) {
      this.$emit('select-change', values);
    },
  },
};
</script>

<style lang="less" scoped>
.multiple-choice {
  width: 100%;

  /deep/ .ivu-checkbox-group {
    display: flex;
    flex-direction: column;

    > .ivu-checkbox-group-item {
      display: flex;
      align-items: center;
      height: 30px;
      font-size: 12px;

      > .ivu-checkbox {
        margin-right: 8px;

        &.ivu-checkbox-disabled + span {
          color: @font-primary-color;
        }
      }
    }
  }
}
</style>
